import { ViewModel, View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { InvoicesListViewModel } from "../invoicesList/invoicesList-viewModel";
import { CreateReturnInvoiceView } from "./createReturnInvoice-view";
import { translate } from "src/common/utilities";

export class CreateReturnInvoiceViewModel extends ViewModel implements IPopup {
    constructor(parentViewModel: InvoicesListViewModel, id) {
        super(parentViewModel);
        this.loadById(id);
        this._typedParent = parentViewModel;
        this.isEvaluating = false;
        this.lineItems = ObservableArray.create<InvoiceLineItem>();
    }
    GetDefaultView(): View<ViewModel> {
        return new CreateReturnInvoiceView();
    }
    public getTypeId(): string {
        return "VM-9B4F10EA-A7ED-4A91-9686-78CC62730501"
    }
    private _typedParent: InvoicesListViewModel;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName; } private _customerName: string;
    public set customerCode(v: string) { this._customerCode = v; } public get customerCode(): string { return this._customerCode; } private _customerCode: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId; } private _warehouseId: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName; } private _sellerName: string;
    public set invoiceNumber(v: string) { this._invoiceNumber = v; } public get invoiceNumber(): string { return this._invoiceNumber; } private _invoiceNumber: string;
    public set parentInvoiceNumber(v: string) { this._parentInvoiceNumber = v; } public get parentInvoiceNumber(): string { return this._parentInvoiceNumber; } private _parentInvoiceNumber: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice; } private _totalPrice: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice; } private _finalPrice: number;
    public set totalDeficit(v: number) { this._totalDeficit = v; } public get totalDeficit(): number { return this._totalDeficit; } private _totalDeficit: number;
    public set totalAmount(v: number) { this._totalAmount = v; } public get totalAmount(): number { return this._totalAmount; } private _totalAmount: number;
    public set totalAdditions(v: number) { this._totalAdditions = v; } public get totalAdditions(): number { return this._totalAdditions; } private _totalAdditions: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set state(v: number) { this._state = v; } public get state(): number { return this._state; } private _state: number;
    public set lineItems(v: ObservableArray<InvoiceLineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<InvoiceLineItem> { return this._lineItems; } private _lineItems: ObservableArray<InvoiceLineItem>;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    async loadById(invoiceId: string) {
        let result = await ServerConnection.callServer('Complex/PurchaseServices/GetPurchaseFactorDetail', {
            Id: invoiceId,
        });
        this.id = invoiceId;
        this.customerName = result.PersonnelName;
        this.customerCode = result.PersonnelCode;
        this.warehouseName = result.WarehouseName;
        this.warehouseId = result.WarehouseId;
        this.invoiceNumber = result.FactorNo;
        this.totalDeficit = 0;
        this.totalAdditions = 0;
        this.lineItems.update(...result.LineItems.map((q, i) => {
            let r = new InvoiceLineItem(this);
            r.rowNumber = i + 1;
            r.id = q.MeasuredProductId;
            r.productName = q.ProductName;
            r.productCode = q.ProductCode;
            r.feePrice = q.Fee;
            r.amount = q.Amount;
            r.count = r.amount;
            r.totalPrice = 0;
            r.deficit = q.Deficits;
            r.showDeficit = 0;
            r.finalPrice = 0;
            r.showAdditional = 0;
            r.additionalPrice = q.Additions;
            return r;
        }));
        this.totalPrice = 0;
        this.totalAmount = 0;
        this.finalPrice = 0;
    }

    private lineItemsChangedTimer: any;
    private isEvaluating: boolean;
    lineItemsChanged() {
        if (this.lineItemsChangedTimer != null)
            clearTimeout(this.lineItemsChangedTimer);
        this.lineItemsChangedTimer = setTimeout(async () => {
            if (this.isEvaluating == false) {
                this.isEvaluating = true;
                await this.calcualteFactor()
                this.isEvaluating = false;
            }
        }, 500);
    }

    private async calcualteFactor() {
        try {
            if (this.lineItems.length == 0) {
                this.totalPrice = 0;
                this.totalAdditions = 0;
                this.totalDeficit = 0;
                this.finalPrice = 0;
                this.totalAmount = 0;
            } else {
                this.isLoading = true;
                this.lineItems.forEach(x => {
                    x.totalPrice = x.feePrice * x.count;
                    x.finalPrice = x.totalPrice + x.showAdditional - x.showDeficit;
                })

                this.totalPrice = this.lineItems.reduce((a, c) => a + c.totalPrice, 0);
                this.finalPrice = this.lineItems.reduce((a, c) => a + c.finalPrice, 0);
                this.totalDeficit = this.lineItems.reduce((a, c) => a + c.showDeficit, 0);
                this.totalAdditions = this.lineItems.reduce((a, c) => a + c.showAdditional, 0);
                this.totalAmount = this.lineItems.reduce((a, c) => a + c.count, 0);
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async createReturnInvoice() {
        try {
            let verificationResult = this.verify();
            if (verificationResult.length > 0) {
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage, translate("createReturnInvoice-viewModel.notPossibleToRegister", {}));
                return;
            }
            let r: string;
            r = await this.messageBoxWarningYesNo(translate("createReturnInvoice-viewModel.returnQuestion", {}), translate("createReturnInvoice-viewModel.returnIvoiceRequest", {}));
            if (r == 'no') {
                return;
            }
            let result = await ServerConnection.callServer('Complex/PurchaseServices/CreateReturnPurchaseInvoice', {
                InvoiceId: this.id,
                WarehouseId: this.warehouseId,
                LineItems: this.lineItems.filter(q => q.count > 0).map(q => {
                    return {
                        MeasuredProductId: q.id,
                        Amount: q.count,
                        ProvidedFee: q.feePrice,
                        Deficits: q.showDeficit,
                        Additions: q.showAdditional,
                    }
                })
            });
            if (result.IsSuccessful == true) {
                await this.messageBoxConfirmSuccess(translate("createReturnInvoice-viewModel.successfullyRegistered", {}), translate("createReturnInvoice-viewModel.successfulOperation", {}));
            } else {
                if (result.Faults[0].Parameters.FaultId === "58E34570-AD7A-460B-B951-607F26AF8AFB" || result.Faults[0].Parameters.FaultId === "7704C1E5-24C1-4F36-BB5D-18F73CAC1497") {
                    throw translate("createReturnInvoice-viewModel.invoiceNotRefundable", {});
                } else {
                    throw translate("createReturnInvoice-viewModel.notPossibleToRegisterInvoice", {});
                }
            }
            this.closePopup();
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex, translate("createReturnInvoice-viewModel.error", {}));
        } finally {
            this._typedParent.refresh();
        }
    }

    verify(): string[] {
        let faults: string[] = [];
        let amountsWithInvalidAmounts = this.lineItems.filter(x => x.count < 0);
        if (amountsWithInvalidAmounts.length > 0) {
            faults.push(translate("createCodeConversion-viewModel.negativeAmountError", {
                rowNoList: amountsWithInvalidAmounts.map(x => x.rowNumber)
            }));
        }
        let exessiveAmounts = this.lineItems.filter(x => x.count > x.amount);
        if (exessiveAmounts.length > 0) {
            faults.push(translate("createCodeConversion-viewModel.moreThanInvoiceError", {
                rowNoList: amountsWithInvalidAmounts.map(x => x.rowNumber)
            }));
        }
        if (this.lineItems.every(x => x.count == 0)) {
            faults.push(translate("createReturnInvoice-viewModel.rowsNumberError", {}));
        }
        return faults;
    }

    closePopup() {

    }
}

export class InvoiceLineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: CreateReturnInvoiceViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent: CreateReturnInvoiceViewModel;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set saleFromWarehouseId(v: string) { this._saleFromWarehouseId = v; } public get saleFromWarehouseId(): string { return this._saleFromWarehouseId; } private _saleFromWarehouseId: string;
    public set saleFromWarehouseName(v: string) { this._saleFromWarehouseName = v; } public get saleFromWarehouseName(): string { return this._saleFromWarehouseName; } private _saleFromWarehouseName: string;
    public set deliveryWarehouseId(v: string) { this._deliveryWarehouseId = v; } public get deliveryWarehouseId(): string { return this._deliveryWarehouseId; } private _deliveryWarehouseId: string;
    public set deliveryWarehouseName(v: string) { this._deliveryWarehouseName = v; } public get deliveryWarehouseName(): string { return this._deliveryWarehouseName; } private _deliveryWarehouseName: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set count(v: number) {
        this._count = getAsNumber(v, true);
        this._count = this._count > this.amount ? this.amount : this._count;
        this.showDeficit = this._count > 0 ? Math.floor(this.deficit * this._count / this.amount) : 0;
        this.showAdditional = this._count > 0 ? Math.floor(this.additionalPrice * this._count / this.amount) : 0;
        this._typedParent.lineItemsChanged();
    } public get count(): number { return this._count; } private _count: number;
    public set feePrice(v: number) { this._feePrice = v; } public get feePrice(): number { return this._feePrice; } private _feePrice: number;
    public set deficit(v: number) { this._deficit = v; } public get deficit(): number { return this._deficit; } private _deficit: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice; } private _finalPrice: number;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice; } private _totalPrice: number;
    public set additionalPrice(v: number) { this._additionalPrice = v; } public get additionalPrice(): number { return this._additionalPrice; } private _additionalPrice: number;
    public set showAdditional(v: number) { this._showAdditional = v; } public get showAdditional(): number { return this._showAdditional; } private _showAdditional: number;
    public set showDeficit(v: number) { this._showDeficit = v; } public get showDeficit(): number { return this._showDeficit; } private _showDeficit: number;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName; } private _unitName: string;

}
